import { Domains, Languages } from "@/core/types/types";

const domainToLanguageMatrix: Record<Domains, Languages> = {
  [Domains.NET]: Languages.EN,
  [Domains.COM]: Languages.EN,
  [Domains.UK]: Languages.EN,
  [Domains.DE]: Languages.DE,
  [Domains.AT]: Languages.DE,
  [Domains.ES]: Languages.ES,
  [Domains.FR]: Languages.FR,
  [Domains.DK]: Languages.DA,
  [Domains.SE]: Languages.SV,
  [Domains.NO]: Languages.NO,
  [Domains.FI]: Languages.FI,
  [Domains.DEFAULT]: Languages.DE,
};

const getLanguageByDomain = (tld: Domains): Languages => {
  const isLanguageFound: boolean = tld in domainToLanguageMatrix;
  return isLanguageFound
    ? domainToLanguageMatrix[tld as Domains]
    : domainToLanguageMatrix[Domains.NET];
};

export default getLanguageByDomain;
